import React from 'react';
import Mobile from './Mobile';
import Desktop from './Desktop';
import {useMediaQuery} from 'react-responsive';

function ViewRenderer(props) {
  const isMobile = useMediaQuery({maxWidth: 767});
  if (isMobile) {
    return <Mobile {...props} />;
  }
  return <Desktop {...props} />;
}

export default ViewRenderer;
